// extracted by mini-css-extract-plugin
export default {"tableBtn":"ProductRewards_tableBtn__9gnfd","noRewards":"ProductRewards_noRewards__M2MqV"};